
import { useEffect } from "react";

/**
 * Hook to check if permissions have been modified from initial state
 */
export const useDirtyCheck = ({
  permissions,
  initialPermissions,
  isLoading,
  isDirty, 
  setIsDirty,
  initialized,
  didSaveRef
}) => {
  // Update isDirty state whenever permissions change
  useEffect(() => {
    if (!isLoading && initialized.current) {
      // Skip dirty check if we just saved
      if (didSaveRef.current) {
        console.log("[useRolePermissions] Skipping dirty check after save operation");
        didSaveRef.current = false;
        return;
      }
      
      // Use JSON.stringify for deep comparison
      const currentPermissionsJson = JSON.stringify(permissions);
      const initialPermissionsJson = JSON.stringify(initialPermissions);
      const newIsDirty = currentPermissionsJson !== initialPermissionsJson;
      
      if (newIsDirty !== isDirty) {
        console.log("[useRolePermissions] isDirty state changing:", newIsDirty);
        
        // Log length of both for debugging
        if (newIsDirty) {
          console.log("[useRolePermissions] Permission comparison details:", {
            currentLength: permissions?.length || 0,
            initialLength: initialPermissions?.length || 0,
            currentJsonLength: currentPermissionsJson?.length || 0,
            initialJsonLength: initialPermissionsJson?.length || 0,
          });
        }
        
        setIsDirty(newIsDirty);
      }
    }
  }, [permissions, initialPermissions, isLoading, isDirty, setIsDirty, initialized, didSaveRef]);
};
